var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#23A0E5",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220.90723,35.09277A11.85078,11.85078,0,0,0,209.165,32.02832L22.83691,84.582a12.00013,12.00013,0,0,0-1.8789,22.39453l85.61035,40.55176a4.01536,4.01536,0,0,1,1.90234,1.90234L149.02344,235.042a11.89209,11.89209,0,0,0,10.81152,6.86524q.51563,0,1.03711-.04395a11.90291,11.90291,0,0,0,10.5459-8.70019L223.97168,46.835A11.853,11.853,0,0,0,220.90723,35.09277Zm-4.63477,9.57032L163.71875,230.99121a4.00009,4.00009,0,0,1-7.46484.62695l-40.55371-85.6123-.01709-.03272L158.94629,102.71A3.99957,3.99957,0,0,0,153.29,97.05371l-43.26318,43.26294c-.01124-.00537-.022-.01245-.0337-.01782L24.38184,99.74609a4.00009,4.00009,0,0,1,.627-7.46484L211.33691,39.72754a4.15049,4.15049,0,0,1,1.13379-.16211A3.98288,3.98288,0,0,1,215.251,40.749,3.92519,3.92519,0,0,1,216.27246,44.66309Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/paper-plane.8f998a9c2ef7284fae87e8eb4bfb7fd6.svg";
export { ForwardRef as ReactComponent };